import { useSearchParams } from 'react-router-dom';
import { Link } from '@gusto/workbench';
import trackSignInClicked from 'packages/signup/analytics/trackSignInClicked';
import useResponsive from 'packages/signup/helpers/useResponsive';

const FOOTER_COPY = {
  nonOrganic: {
    copy: 'Already use Gusto?',
    linkCopy: 'Sign in',
    linkUrl: `/login`,
    copyStyle: 'text-default grey-text',
    hasLineBreak: false,
  },
  organic: {
    copy: 'Not ready to create an account?',
    linkCopy: 'Learn how Gusto works',
    linkUrl: 'company/explore',
    copyStyle: 'text-default c-black-1000 learn-how-gusto-works',
    hasLineBreak: true,
  },
  findYourPlan: {
    copy: 'Not ready to create an account?',
    linkCopy: 'Find your plan',
    linkUrl: 'company/explore',
    copyStyle: 'text-default c-black-1000 learn-how-gusto-works',
    hasLineBreak: true,
  },
  null: {
    copy: '',
    linkCopy: '',
    linkUrl: '',
    copyStyle: '',
    hasLineBreak: false,
  },
};

export const SinglePageFooter = ({
  content,
}: {
  content: {
    copyStyle: string;
    copy: string;
    hasLineBreak: boolean;
    linkUrl: string;
    linkCopy: string;
  };
}) => {
  const [searchParams] = useSearchParams();

  return (
    <p className={content?.copyStyle}>
      {content?.copy}
      {content?.hasLineBreak && <br />}
      <Link
        onClick={trackSignInClicked}
        href={
          searchParams && content?.linkUrl !== '/login'
            ? `${content?.linkUrl}?${searchParams}`
            : content?.linkUrl
        }
      >
        {content?.linkCopy}
      </Link>
    </p>
  );
};

const SinglePageFooterWrapper = ({ contentType }: { contentType: string }) => {
  const { isMobile } = useResponsive();
  let contentCopy;
  switch (contentType) {
    case 'non-organic':
      contentCopy = FOOTER_COPY.nonOrganic;
      break;
    case 'findYourPlan':
      contentCopy = FOOTER_COPY.findYourPlan;
      break;
    default:
      contentCopy = isMobile ? FOOTER_COPY.null : FOOTER_COPY.organic;
  }

  return <SinglePageFooter content={contentCopy} />;
};

export default SinglePageFooterWrapper;
